module.exports = {"fr-FR":{"echo":{"show":{"shout":"Tout ce qui part...","placeholder":"... revient !"}}}}